"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateRangePicker = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("react-dates/initialize");

var _reactDates = require("react-dates");

var _label = _interopRequireDefault(require("../form/label"));

var _moment = _interopRequireDefault(require("moment"));

require("react-dates/lib/css/_datepicker.css");

var _classnames = _interopRequireDefault(require("classnames"));

var _index = _interopRequireDefault(require("./index.scss"));

var _types = require("./types");

var _helpers = require("./helpers");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var DateRangePicker = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(DateRangePicker, _React$Component);

  function DateRangePicker(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, DateRangePicker);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(DateRangePicker).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onDatesChange", function (onChange) {
      return function (_ref) {
        var startDate = _ref.startDate,
            endDate = _ref.endDate;

        _this.setState({
          startDate: startDate,
          endDate: endDate
        });

        onChange && onChange({
          startDate: startDate,
          endDate: endDate
        });
      };
    });
    var initialStartDate = props.initialStartDate,
        initialEndDate = props.initialEndDate,
        rest = (0, _objectWithoutProperties2["default"])(props, ["initialStartDate", "initialEndDate"]);
    _this.renderProps = rest;
    _this.state = {
      startDate: initialStartDate && (0, _moment["default"])(initialStartDate),
      endDate: initialEndDate && (0, _moment["default"])(initialEndDate),
      focusedInput: null
    };
    _this.onDatesChange = _this.onDatesChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onFocus = _this.onFocus.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(DateRangePicker, [{
    key: "render",
    value: function render() {
      var _this$renderProps = this.renderProps,
          className = _this$renderProps.className,
          label = _this$renderProps.label,
          onChange = _this$renderProps.onChange,
          restProps = (0, _objectWithoutProperties2["default"])(_this$renderProps, ["className", "label", "onChange"]);
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])(_index["default"].DateRangePicker, className)
      }, _react["default"].createElement(_label["default"], null, label), _react["default"].createElement(_reactDates.DateRangePicker, (0, _extends2["default"])({
        displayFormat: _helpers.longDateDisplayFormat,
        startDateId: "startDate",
        endDateId: "endDate",
        startDate: this.state.startDate,
        endDate: this.state.endDate,
        onDatesChange: this.onDatesChange(onChange),
        focusedInput: this.state.focusedInput,
        onFocusChange: this.onFocus,
        minimumNights: this.props.minimumNights,
        hideKeyboardShortcutsPanel: true
      }, restProps)));
    }
  }, {
    key: "onFocus",
    value: function onFocus(focusedInput) {
      this.setState({
        focusedInput: focusedInput
      });
    }
  }]);
  return DateRangePicker;
}(_react["default"].Component);

exports.DateRangePicker = DateRangePicker;
DateRangePicker.propTypes = _objectSpread({
  initialStartDate: (0, _types.datePropType)(_moment["default"]),
  initialEndDate: (0, _types.datePropType)(_moment["default"]),
  minimumNights: _propTypes["default"].number,
  className: _propTypes["default"].string
}, _types.sharedPropTypes);
DateRangePicker.defaultProps = {
  minimumNights: 0
};